import { useEffect, useState } from 'react'

import { axiosInstance } from '../providers/rest-data-provider/utils/axios'

interface BetterStackStatus {
	status: 'operational' | 'degraded_performance' | 'partial_outage' | 'major_outage' | 'unknown'
	announcement: string
	company_name: string
}

export function useBetterStackStatus() {
	const [status, setStatus] = useState<BetterStackStatus | null>(null)
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState<string | null>(null)

	useEffect(() => {
		// NOTE: void calling this for now as call is throwing errors
		setStatus({
			status: 'unknown',
			announcement: '',
			company_name: '',
		})
		return

		const fetchStatus = async () => {
			setLoading(true)
			setError(null)

			try {
				const response = await axiosInstance.get('/betterstack/status')
				if (response.data.error) {
					throw new Error(response.data.error)
				}
				setStatus(response.data)
			} catch (err) {
				setError(err instanceof Error ? err.message : 'Unknown error')
			} finally {
				setLoading(false)
			}
		}

		fetchStatus()
		const interval = setInterval(fetchStatus, 5 * 60 * 1000)
		return () => clearInterval(interval)
	}, [])

	return { status, loading, error }
}
